import Tabs from "@/shared/data-display/tabs";
import { ReactNode } from "react";
import { generatePath, useNavigate } from "react-router-dom";
import { useTranslations } from "use-intl";
import { COMPANY_DOCUMENTS_EDIT_PATH } from "./company-documents-edit-path";

export enum TabsEnum {
  GENERAL = "general",
  PARTICIPANTS = "participants",
}

export function CompanyDocumentsEditTabs({
  tab,
  documentId,
  general,
  participants,
}: {
  tab: string | undefined;
  documentId: string;
  general: ReactNode;
  participants: ReactNode;
}) {
  const t = useTranslations("Documents");
  const navigate = useNavigate();

  return (
    <Tabs
      destroyInactiveTabPane
      activeKey={tab ?? TabsEnum.GENERAL}
      onChange={(tab) => {
        navigate(
          generatePath(COMPANY_DOCUMENTS_EDIT_PATH, {
            documentId,
            tab,
          }),
        );
      }}
      items={[
        {
          key: TabsEnum.GENERAL,
          label: t("General"),
          children: general,
        },
        {
          key: TabsEnum.PARTICIPANTS,
          label: t("Participants"),
          children: participants,
        },
      ]}
    />
  );
}
